module.exports = __webpack_public_path__ + "img/imanandai_logo_light.c4cdb35f.svg";